import React from "react";
import moment from "moment";
import "./CustomWeekHeader.css";

const CustomWeekHeader = ({ date, localizer }) => {
  const today = moment();
  const isToday = moment(date).isSame(today, "day");
  const dayName = localizer.format(date, "ddd", "en").toUpperCase();
  const dayNumber = localizer.format(date, "D", "en");

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div className="custom-week-header" onClick={handleClick}>
      <div className={`date-number ${isToday ? "today" : ""}`}>{dayNumber}</div>
      <div className="weekday-name">{dayName}</div>
    </div>
  );
};

export default CustomWeekHeader;
